import React from 'react'
import { useNavigate } from 'react-router-dom';
import "./BackButton.css";
import { TranslationEnum, usePortalTranslation } from '../../../providers/TranslationProvider';


const CUR_COMPONENT = "Common Component"

const BackButton = () => {
  const {translate} =usePortalTranslation();
  const navigate = useNavigate();
  return (
    <button
        className="portal-back-button"
        onClick={() => {
            navigate(-1);
        }}
    >
      {translate(TranslationEnum.common_component,"BACK")}
    </button>
  )
}

export default BackButton